const UPDATE_PAYMENTS = (state, data) => {
	state.payments = data;
};

export default {
	UPDATE_PAYMENTS
};
